import YoutubeIcon from "../../../assets/images/generico/YoutubeIcon";
import FacebookIcon from "../../../assets/images/generico/FacebookIcon";
import InstagramIcon from "../../../assets/images/generico/InstagramIcon";
import "./SocialSidebar.css";
import { PortalContext } from "../../../context/Provider";
import { useContext } from "react";

const SocialSidebar = ({cssCustom, colorLink}) => {
  const {
    textosState, 
  } = useContext(PortalContext);

  const facebook = textosState.textos.data?.urlFacebook ? textosState.textos.data.urlFacebook.descripcion : undefined;
  const instagram =  textosState.textos.data?.urlInstagram ? textosState.textos.data.urlInstagram.descripcion : undefined;
  const youtube = textosState.textos.data?.urlYoutube? textosState.textos.data.urlYoutube.descripcion : undefined;

  return (
    <div className={`homeSocialContainer ${cssCustom}`}>
      {
        instagram ? 
        <a target="_blank" href={instagram} className="socialIcon" rel="noreferrer">
        <InstagramIcon color={colorLink ? colorLink : "#A6A6A6"} />
      </a>: ""
      }
      {
        facebook ? 
        <a target="_blank" href={facebook} className="socialIcon" rel="noreferrer">
        <FacebookIcon color={colorLink ? colorLink : "#A6A6A6"} />
      </a>: ""
      }
      {
        youtube ? 
        <a target="_blank" href={youtube}className="socialIcon" rel="noreferrer" >
        <YoutubeIcon color={colorLink ? colorLink : "#A6A6A6"} />
      </a>: ""
      }
      
    </div>
  );
};

export default SocialSidebar;
